<script setup lang="ts">
defineProps<{
  active?: boolean;
}>();
</script>

<template>
  <template v-if="!active">
    <svg xmlns="http://www.w3.org/2000/svg" id="Livello_1" data-name="Livello 1" viewBox="0 0 50 50" fill="currentColor">
      <path
        d="M39.76 24.42h-11.2c-.42 0-.8-.27-.94-.67-.41-1.15-1.48-1.92-2.66-1.92h-.11c-1.15.05-2.14.79-2.54 1.92-.14.4-.52.67-.94.67h-11.2c-.55 0-1-.45-1-1 0-.46.06-11.39 5.6-17.22 1.38-1.45 3.07-3.24 6.72-3.66V.94c0-.55.45-1 1-1h4.93c.55 0 1 .45 1 1v1.61c3.67.42 5.36 2.21 6.73 3.66 5.54 5.76 5.6 16.75 5.6 17.21 0 .55-.45 1-1 1Zm-10.54-2h9.51c-.15-2.76-.93-10.58-5.01-14.83-1.44-1.52-2.79-2.96-6.33-3.12a1 1 0 0 1-.95-1V1.94h-2.93v1.52c0 .53-.42.97-.95 1-3.52.16-4.88 1.6-6.32 3.11-4.08 4.3-4.87 12.08-5.02 14.84h9.51c.83-1.57 2.46-2.59 4.25-2.59.05 0 .1 0 .15.01 1.72.06 3.28 1.06 4.09 2.58ZM44.23 35.42H5.77c-.35 0-.68-.19-.86-.49a1 1 0 0 1-.02-.99l3.88-7.12c.04-.51.47-.92 1-.92h11.6c.42 0 .8.27.94.67.4 1.13 1.44 1.85 2.66 1.85s2.25-.75 2.66-1.87c.14-.39.52-.65.94-.65h11.66c.53 0 .96.4 1 .92l3.88 7.12a1 1 0 0 1-.02.99c-.18.3-.51.49-.86.49Zm-36.77-2h35.08l-3.01-5.51H29.2c-.84 1.53-2.47 2.52-4.24 2.52s-3.42-.97-4.25-2.52H10.46l-3 5.51Z"
      />
      <path
        d="M25.1 50.06c-8.39 0-14.92-6.71-15.2-15.61 0-.27.09-.53.28-.73s.45-.3.72-.3h28.33c.27 0 .53.11.72.3.19.19.29.46.28.73-.29 8.9-6.79 15.61-15.13 15.61ZM11.97 35.42c.69 7.27 6.18 12.64 13.13 12.64s12.37-5.36 13.07-12.64h-26.2Z"
      />
    </svg>
  </template>
  <template v-else>
    <svg xmlns="http://www.w3.org/2000/svg" id="Livello_1" data-name="Livello 1" viewBox="0 0 50 50" fill="currentColor">
      <path
        d="M24.97 21.08c1.74 0 3.22 1.15 3.78 2.72H40.5c0-.56-.14-11.67-5.59-17.34-1.6-1.7-3.29-3.41-7.35-3.6V.21h-5.17v2.64c-4.06.19-5.73 1.89-7.35 3.6-5.45 5.73-5.59 16.78-5.59 17.34H21.2c.56-1.57 2.02-2.71 3.78-2.71ZM45.18 35.34l-4.2-7.7v-.19H28.74c-.56 1.52-2.02 2.64-3.78 2.64s-3.22-1.07-3.78-2.64H9.01v.19l-4.2 7.7h5.45c.69 8.47 7.07 14.44 14.83 14.44s14.07-5.96 14.76-14.44h5.31Z"
      />
    </svg>
  </template>
</template>
